var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"disabled":_vm.getIsGenerating},on:{"click":function($event){return _vm.generate()}}},[_vm._v("Generate")])
}
var staticRenderFns = []

export { render, staticRenderFns }